import { apiService } from './axios.client';

export const PlanEndPoints = {
    setPlanSession: function (input, callback) {
        apiService.post('/PlanSession/setPlanSession', input)
            .then((response) => callback(response, input))
            .catch(callback());
    },
    updatePlanSession: function (input, callback) {
        apiService.post('/PlanSession/updatePlanSession', input)
            .then((response) => callback(response, input))
            .catch(error => alert(error.response.data.message));
    },
    getPlanSessionById: function (input, callback) {
        apiService.get('/PlanSession/getPlanSessionById', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    getAllPlanSession: function (input, callback) {
        apiService.get('/PlanSession/getAllPlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    deletePlanSession: function (input, callback) {
        apiService.post('/PlanSession/deletePlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    importPlanSession: function (input, callback) {
        apiService.post('/PlanSession/importPlanSession', input)
            .then((response) => callback(response, input))
            .catch(error => alert(error));
    },
    exportPlanSession: function (input, callback) {
        apiService.get('/PlanSession/exportPlanSession', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    uploadReportCapture: function (input, callback) {
        apiService.post('/PlanSession/uploadReportCapture', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
    uploadTestPDF: function (input, callback) {
        apiService.post('/PlanSession/uploadTestPDF', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
}